import { InformalFeedbackRequestNotification as InformalFeedbackRequestNotificationType } from '../../types'
import { NotificationSubjectType } from 'types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import { articleOrLayerPath } from '../../utils'
import { titleForDeprecatedType, iconForNotification } from './utils'
import { ReviewCreatedNotification } from './ReviewCreatedNotification'
import { ReviewSubmittedNotification } from './ReviewSubmittedNotification'
import { ReviewDismissedNotification } from './ReviewDismissedNotification'

interface Props {
  notification: InformalFeedbackRequestNotificationType
  onClose: () => void
}

export const InformalFeedbackRequestNotification = (props: Props) => {
  const { notification } = props
  const subjectType = notification.subject.subject_type

  switch (subjectType) {
    case NotificationSubjectType.InformalFeedbackReviewsCreated:
    case NotificationSubjectType.InformalFeedbackViewersCreated:
    case NotificationSubjectType.InformalFeedbackViewersCoCreated:
    case NotificationSubjectType.DesignInformalFeedbackReviewsCreated:
      return <ReviewCreatedNotification {...props} />
    case NotificationSubjectType.InformalFeedbackReviewSubmitted:
    case NotificationSubjectType.DesignInformalFeedbackReviewSubmitted:
      return <ReviewSubmittedNotification {...props} />
    case NotificationSubjectType.InformalFeedbackReviewDismissed:
    case NotificationSubjectType.DesignInformalFeedbackReviewDismissed:
      return <ReviewDismissedNotification {...props} />
    default:
      return (
        <BaseNotificationItem
          {...props}
          title={titleForDeprecatedType(subjectType)}
          icon={iconForNotification(notification)}
          path={articleOrLayerPath({ notification })}
          aria-label="Review Notification"
        />
      )
  }
}
